// extracted by mini-css-extract-plugin
export default {"decks":"ManageTeamsForm-module--decks--YG8xI","delete-button":"ManageTeamsForm-module--delete-button--mhYY5","team-name":"ManageTeamsForm-module--team-name--X+msw"};